module.exports = [
  {
    title: 'Sievert',
    slug: 'sievert',
    message: 'Simulate Future Problems Today.',
    summary: 'A simulation-focused web project for exploring possible future problems before they become real issues.',
    details: [
      'Sievert turns scenario thinking into an interactive product surface. It combines a Vue interface with Python and CSS work to make simulations feel direct, fast, and easy to inspect.',
      'The project includes landing, profile, mobile, and simulation screens, so the experience can move from a first explanation into a practical simulation flow.'
    ],
    highlights: [
      'Interactive simulation experience',
      'Responsive product screens'
    ],
    technologies: ['Vue', 'Python', 'CSS'],
    coverImage: '/images/project-covers/sievert.png',
    image: '/images/sievert/sieverthome.webp',
    media: [
      { type: 'image', src: '/images/sievert/sieverthome.webp', title: 'Home' },
      { type: 'image', src: '/images/sievert/sievertabout.webp', title: 'About' },
      { type: 'image', src: '/images/sievert/sievertmobile.webp', title: 'Mobile' }
    ],
    link: 'https://sievert.noirlang.tr'
  },
  {
    title: 'AMELE',
    slug: 'amele',
    message: 'Unified digital forensics platform bringing disk, RAM, container drift, logical acquisition, and backup analysis together for Windows, Linux, Docker, Android, and iOS.',
    summary: 'Unified digital forensics platform bringing disk, RAM, container drift, logical acquisition, and backup analysis together for Windows, Linux, Docker, Android, and iOS.',
    details: [
      'Amele is a desktop forensic acquisition tool for authorized investigations. It brings disk imaging, memory acquisition, Android collection, iOS backup normalization, Docker container DFIR, hash verification, case output handling, image viewing, and reporting into one native application.',
      'Local & Remote Disk Acquisition: Create raw disk images from local disks or image files with RAW or AFF4 output formatting. Collect disk images through the Amele Linux and Windows agents or agentless SSH/WinRM streaming with live throughput and hashing.',
      'Memory (RAM) Acquisition: Capture volatile RAM with AVML on Linux and WinPMEM on Windows, plus remote memory dumps via Agent or Agentless SSH streaming (/proc/kcore, AVML, WinPMEM).',
      'Mobile Forensics (Android & iOS): Verify ADB status, list devices, collect logical/filesystem/volatile data on Android. Normalize iTunes/Finder backups on iOS into browsable Backup2FS file system with per-file MD5/SHA1/SHA256 CSV logging.',
      'Docker & Container DFIR: Audit container escape risks, scan environment variables for exposed secrets/API keys, extract raw configs and logs, package runtime Overlay2 UpperDir drift layers, and stream remote container evidence via Linux Agent.',
      'Case Management & Verification: Store acquisitions, notes, hashes, reports, and case_manifest.json integrity inventories. Calculate MD5, SHA1, SHA256, and SHA512 hashes, mount supported images read-only, and generate comprehensive forensic reports.'
    ],
    highlights: [
      'Disk & RAM Acquisition (RAW, AFF4)',
      'Agentless Remote Streaming (SSH / WinRM)',
      'Docker & Container DFIR Drift Layers',
      'Android & iOS Backup Normalization',
      'Integrity Verification & Case Reporting'
    ],
    technologies: ['Rust', 'GTK3', 'WebKit2GTK', 'AFF4', 'Docker', 'Android', 'iOS'],
    coverImage: '/images/project-covers/amele.png',
    image: '/images/project-covers/amele.png',
    media: [
      { type: 'video', src: '/images/amele/amele.gif', poster: '/images/project-covers/amele.png', title: 'Amele Forensic Tool Demo' }
    ],
    link: 'https://amele.noirlang.tr',
    github: 'https://github.com/noirlang/amele'
  },
  {
    title: 'Anons',
    slug: 'anons',
    status: 'Soon',
    message: 'The single destination for institutional announcements.',
    summary: 'The single destination for institutional announcements. Anons brings announcements from followed organizations into one unified feed with automated text-to-speech audio and multimedia broadcasts.',
    details: [
      'Anons is a centralized institutional announcement and broadcasting platform. It consolidates announcements from followed public bodies, municipalities, universities, and emergency services into a single clean chronological feed.',
      'Automated Neural Text-to-Speech (TTS): Text-based announcements are automatically synthesized into high-quality spoken audio using Microsoft Edge Neural TTS with offline fallback, enabling users to listen to announcements on the go.',
      'Rich Media & Video Broadcasts: Organizations can publish verified announcements with high-resolution image galleries, video announcements, and audio attachments across responsive dark and light themes.',
      'Organization & Admin Workflows: Verified institution onboarding pipeline with administrative provisioning, multi-organization member management, and mobile-ready REST APIs.'
    ],
    highlights: [
      'Unified Feed for Followed Organizations',
      'Automated Neural TTS Audio Announcements',
      'Multimedia & Video Broadcast Publishing',
      'Institution Verification & Role Management',
      'High-Contrast Responsive UI (Light / Dark)'
    ],
    technologies: ['Ruby on Rails', 'Nuxt', 'Vue', 'Edge-TTS', 'SQLite', 'REST API'],
    coverImage: '/images/project-covers/anons.png',
    image: '/images/project-covers/anons.png',
    media: [
      { type: 'image', src: '/images/project-covers/anons.png', title: 'Anons Platform Overview' }
    ]
  },
  {
    title: 'CodeTasker',
    slug: 'codetasker',
    message: 'Two-Way GitHub TODO & Task Management Platform.',
    summary: 'A two-way GitHub TODO and task management platform that keeps repositories, tasks, editors, and notifications in sync.',
    details: [
      'CodeTasker focuses on turning repository work into an operational dashboard. It brings task lists, synced repositories, editor flows, collaborators, and notification states into one place.',
      'The Go and React stack supports a web product surface where GitHub work can be tracked, edited, and reviewed without leaving the task context.'
    ],
    highlights: [
      'Repository and task synchronization',
      'Dashboard, editor, and notification views'
    ],
    technologies: ['Go', 'React'],
    coverImage: '/images/project-covers/codetasker.png',
    image: '/images/codetasker/dashboard.png',
    media: [
      { type: 'image', src: '/images/codetasker/dashboard.png', title: 'Dashboard' },
      { type: 'image', src: '/images/codetasker/task-list.png', title: 'Task List' },
      { type: 'image', src: '/images/codetasker/create-todo.png', title: 'Create Todo' },
      { type: 'image', src: '/images/codetasker/editor.png', title: 'Editor' },
      { type: 'image', src: '/images/codetasker/repository-panel.png', title: 'Repository Panel' },
      { type: 'image', src: '/images/codetasker/synced-repositories.png', title: 'Synced Repositories' },
      { type: 'image', src: '/images/codetasker/collaborators.png', title: 'Collaborators' },
      { type: 'image', src: '/images/codetasker/settings.png', title: 'Settings' },
      { type: 'image', src: '/images/codetasker/email-notification.png', title: 'Email Notification' }
    ],
    link: 'https://codetasker.noirlang.tr',
    github: 'https://github.com/noirlang/codetasker'
  },
  {
    title: 'Moviescore',
    slug: 'moviescore',
    message: 'Moviescore is a modern social platform for movie enthusiasts.',
    summary: 'A modern social movie platform for discovery, movie details, reviews, profiles, and community activity.',
    details: [
      'Moviescore is designed as a social product around film discovery and discussion. The available screens cover home, trending movies, movie details, reviews, profile, and movie publishing flows.',
      'The Vue, Go, and MongoDB stack gives the project a full product shape: interactive client experience, backend services, and persistent social content.'
    ],
    highlights: [
      'Movie discovery and detail pages',
      'Review and profile flows'
    ],
    technologies: ['Vue', 'Go', 'MongoDB'],
    image: '/images/moviescore/home.webp',
    media: [
      { type: 'image', src: '/images/moviescore/home.webp', title: 'Home' },
      { type: 'image', src: '/images/moviescore/trendingmovie.webp', title: 'Trending Movies' },
      { type: 'image', src: '/images/moviescore/moviedetails.webp', title: 'Movie Details' },
      { type: 'image', src: '/images/moviescore/moviereviews.webp', title: 'Reviews' },
      { type: 'image', src: '/images/moviescore/profile.webp', title: 'Profile' },
      { type: 'image', src: '/images/moviescore/pushfilm.webp', title: 'Publish Movie' }
    ],
    github: 'https://github.com/melihemik/moviescore'
  },
  {
    title: 'Hyperstructure',
    slug: 'hyperstructure',
    message: 'Modern social app experience.',
    summary: 'A modern social application experience with feed, discovery, profile, messaging, notifications, and account flows.',
    details: [
      'Hyperstructure explores a complete social app surface rather than a single isolated page. It includes feed, explore, profile, messaging, notifications, settings, login, register, and post creation screens.',
      'The project pairs a Next.js interface with Rust and MongoDB work, making it a full-stack social product experiment.'
    ],
    highlights: [
      'Feed, discovery, and profile screens',
      'Messaging and notification flows'
    ],
    technologies: ['Next.js', 'Rust', 'MongoDB'],
    image: '/images/hype/anasayfa.webp',
    media: [
      { type: 'image', src: '/images/hype/anasayfa.webp', title: 'Home' },
      { type: 'image', src: '/images/hype/akis.webp', title: 'Feed' },
      { type: 'image', src: '/images/hype/kesfet.webp', title: 'Explore' },
      { type: 'image', src: '/images/hype/kesfet2.webp', title: 'Explore Detail' },
      { type: 'image', src: '/images/hype/profil.webp', title: 'Profile' },
      { type: 'image', src: '/images/hype/mesajlar.webp', title: 'Messages' },
      { type: 'image', src: '/images/hype/bildirimler.webp', title: 'Notifications' },
      { type: 'image', src: '/images/hype/yeni-gonderi.webp', title: 'New Post' },
      { type: 'image', src: '/images/hype/ayarlar.webp', title: 'Settings' },
      { type: 'image', src: '/images/hype/ayarlar2.webp', title: 'Settings Detail' },
      { type: 'image', src: '/images/hype/login.webp', title: 'Login' },
      { type: 'image', src: '/images/hype/register.webp', title: 'Register' },
      { type: 'image', src: '/images/hype/hypemobile.webp', title: 'Mobile' }
    ],
    github: 'https://github.com/melihemik/hyperstructure'
  },
  {
    title: 'Differ',
    slug: 'differ',
    message: 'A focused desktop Git change explorer for commit history, contributors, diffs, and repository status.',
    summary: 'A focused Rust desktop Git change explorer for commit history, contributors, diffs, and repository status.',
    details: [
      'Differ is built for inspecting repository change history without losing context. It brings commits, contributors, diffs, and repository status into one desktop interface.',
      'The project keeps the experience narrow and practical: it is a tool for understanding what changed, who contributed, and what still needs attention.'
    ],
    highlights: [
      'Commit history and contributor views',
      'Diff and repository status inspection'
    ],
    technologies: ['Rust'],
    coverImage: '/images/project-covers/differ.png',
    image: '/images/differ/differ-poster.webp',
    video: 'https://github.com/user-attachments/assets/0b8d5afc-c62e-420d-b321-f82076453d70',
    media: [
      { type: 'video', src: 'https://github.com/user-attachments/assets/0b8d5afc-c62e-420d-b321-f82076453d70', poster: '/images/differ/differ-poster.webp', title: 'Differ Demo' }
    ],
    link: 'https://differ.noirlang.tr',
    github: 'https://github.com/noirlang/differ'
  },
  {
    title: 'Dispatch',
    slug: 'dispatch',
    message: 'Next-generation minimalist email experience powered by AI assistance, instant email translation, sender approval queues, and spy tracker shield security.',
    summary: 'Next-generation minimalist email experience powered by AI assistance, instant email translation, sender approval queues, and spy tracker shield security.',
    details: [
      'Dispatch is a next-generation minimalist email client and productivity platform. It combines visual setup wizards, AI-assisted workflows, sender screening queues, board & calendar syncing, multi-language email translation, and email-powered blogging into a single cohesive workspace.',
      'Sender Approval Queue & AI Calendar Sync: First-time incoming senders are safely routed to an Approvals queue with 1-click Approve or Block actions. Important details like meetings, tracking codes, and deadlines are automatically detected by AI, converted into Dashboard cards, and synced to the Calendar.',
      'AI Email Summaries, Smart Replies & Translation: Long and complex emails are summarized into concise 2-3 bullet points in seconds using Google Gemini, Claude, or OpenAI models; contextual intelligent response drafts can be generated with a single click, and foreign language emails are translated directly inside the reader while preserving original formatting.',
      'Email Management, Contact Groups & Smart Aliases: Manage Inbox, Sent, and Draft folders with full search; broadcast messages to saved contact groups using @group_name syntax (e.g. @team) with automatic member resolution and simultaneous delivery.',
      'Integrated RSS Feed Reader & Background Sync: Subscribe to favorite tech blogs, news sites, and developer feeds; scheduled Sidekiq background workers fetch and synchronize updates periodically without leaving the email experience.',
      'Rich Markdown Formatting & Email-Powered Blogging: Full GitHub Flavored Markdown (GFM) support when composing and replying to emails, plus email-powered blogging allowing authors to publish posts to /@username/slug simply by emailing blog@yourdomain.com.',
      'Registration Modes & Mobile Responsive Interface: Supports invite-code registration, admin-only provisioning, or open registration modes with a clean, fast responsive interface across desktop, tablet, and mobile devices.'
    ],
    highlights: [
      'Sender Approval Queue & Tracker Shield',
      'AI Email Summarization & Smart Replies',
      'AI Multi-Language Email Translation',
      'AI Dashboard & Calendar Sync Integration',
      'Contact Groups & Smart Aliases (@team)',
      'Integrated RSS Feed Reader & Sidekiq Sync',
      'Email-Powered Markdown Blogging Engine'
    ],
    technologies: ['Ruby on Rails', 'React', 'TailwindCSS', 'Sidekiq', 'PostgreSQL', 'Docker', 'AI'],
    coverImage: '/images/project-covers/dispatch.png',
    image: '/images/project-covers/dispatch.png',
    video: 'https://dispatch.noirlang.tr/videos/dispatch-onay-ai-pano-takvim.mp4',
    media: [
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-onay-ai-pano-takvim.mp4',
        poster: '/images/project-covers/dispatch.png',
        title: 'Sender Approval Queue, AI Dashboard & Calendar Integration'
      },
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-aiozet-aiyanit.mp4',
        title: 'AI Email Summarization & Smart Reply Engine'
      },
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-ai-ceviri.mp4',
        title: 'AI-Powered Multi-Language Email Translation'
      },
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-mail-grup.mp4',
        title: 'Email Management, Contact Groups & Smart Aliases'
      },
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-akis-rss.mp4',
        title: 'Integrated RSS Feed Reader & Background Sync'
      },
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-markdown.mp4',
        title: 'Rich Markdown Formatting Support'
      },
      {
        type: 'video',
        src: 'https://dispatch.noirlang.tr/videos/dispatch-blog.mp4',
        title: 'Email-Powered Blogging Engine'
      },
      {
        type: 'image',
        src: '/images/dispatch/admin/admin-kayit-erisim-modu.png',
        title: 'Admin Panel — Registration & Access Modes'
      }
    ],
    link: 'https://dispatch.noirlang.tr',
    github: 'https://github.com/noirlang/dispatch'
  },
  {
    title: 'Forgetag',
    slug: 'forgetag',
    message: 'Rust desktop project from noirLang.',
    summary: 'A Rust desktop project from noirLang, built around a compact native application experience.',
    details: [
      'Forgetag continues the noirLang desktop tooling direction with a Rust-based native app surface.',
      'The project keeps the presentation focused on a packaged desktop experience and a simple product workflow.'
    ],
    highlights: [
      'Native product workflow',
      'noirLang project'
    ],
    technologies: ['Rust'],
    coverImage: '/images/project-covers/forgetag.png',
    image: '/images/forgetag/forgetag-poster.webp',
    video: 'https://github.com/user-attachments/assets/414b277b-60a9-47c8-b173-531b11bb3147',
    media: [
      { type: 'video', src: 'https://github.com/user-attachments/assets/414b277b-60a9-47c8-b173-531b11bb3147', poster: '/images/forgetag/forgetag-poster.webp', title: 'Forgetag Demo' }
    ],
    link: 'https://forgetag.noirlang.tr',
    github: 'https://github.com/noirlang/forgetag'
  },
  {
    title: 'Megaron',
    slug: 'megaron',
    status: 'Soon',
    message: 'Modular company management, operations, and team collaboration workspace.',
    summary: 'Modular company management & operations workspace. Megaron consolidates project workflows, team check-ins, wiki docs, CRM pipelines, financial analytics, and RBAC governance into one unified enterprise platform.',
    details: [
      'Megaron is an all-in-one company operations workspace built on Ruby on Rails 8 and React 19. It eliminates fragmented SaaS subscriptions by bringing project management, communication, documentation, commerce, and governance under a single monochromatic dark interface.',
      'Operations & Project Workflows: Agile Kanban boards with status lanes, subtasks, priorities, and deadline tracking. Automated GitOps captures GitHub push webhooks, parses code comments (// TASK) to link commits and pull requests directly to tasks.',
      'Real-Time Team Collaboration: Chronological vertical calendar scheduling, ActionCable WebSocket chat channels with rich markdown, unread badges, and automated daily asynchronous check-ins for remote engineering teams.',
      'Commerce & Financial Analytics: Integrated CRM sales pipelines with deal valuations, interaction timelines, expense tracking with receipt archives, and corporate asset/hardware inventory checkout logs.',
      'Governance & Security: Dynamic organization-scoped Role-Based Access Control (RBAC) with 25+ granular action permissions, queryable enterprise audit logging, and personal API tokens for automated CLI integration.'
    ],
    highlights: [
      'Operations: Agile Kanban, GitHub Webhooks & GitOps',
      'Team Collaboration: Real-Time Chat & Daily Check-Ins',
      'Commerce: CRM Pipeline, Expense & Inventory Tracking',
      'Governance: Granular RBAC Matrix & Audit Trail Logging',
      'Personal API Tokens & CLI Tooling Integration'
    ],
    technologies: ['Ruby on Rails 8', 'React 19', 'TypeScript', 'MongoDB', 'ActionCable', 'TailwindCSS'],
    coverImage: '/images/project-covers/megaron.png',
    image: '/images/project-covers/megaron.png',
    media: [
      { type: 'image', src: '/images/project-covers/megaron.png', title: 'Megaron Modular Workspace Overview' }
    ]
  }
].sort((projectA, projectB) => projectA.title.localeCompare(projectB.title));

// Commit trace: 2025-07-18T18:49:08 - fix: correct typo in projects.js

// Commit trace: 2025-12-26T06:36:55 - docs: clarify parameter types in projects.js

// Commit trace: 2026-01-20T11:02:12 - refactor: modularize helper functions in projects.js

// Commit trace: 2026-02-18T22:30:57 - fix: resolve minor issue in projects.js

// Commit trace: 2026-03-08T09:47:12 - refactor: modularize helper functions in projects.js
